import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IAddress } from "@app/shared/shared.models";
import { ICountryCode, IGoogleAddressModel, IShippingCountry, IStateModel } from "@app/store/address/address.models";

@Injectable({
	providedIn: "root"
})
export class AddressService {

	constructor(readonly http: HttpClient) { }

	getAddress(id: number) {
		return this.http.get("api/address/getAddress", { params: { id: id.toString() } });
	}

	saveAddress(address: IAddress) {
		return this.http.post<IAddress>("api/address/SaveAddress", address);
	}

	deleteAddress(id: number) {
		return this.http.delete<boolean>("api/address/RemoveAddress", { params: { id: id.toString() } });
	}

	getBillingAddresses() {
		return this.http.get<IAddress[]>("api/address/getBillingAddresses");
	}

	getShippingAddresses() {
		return this.http.get<IAddress[]>("api/address/getShippingAddresses");
	}

	getFinalDestinationAddresses() {
		return this.http.get<IAddress[]>("api/address/getFinalDestinationAddresses");
	}

	geolocateAddress(address: IGoogleAddressModel) {
		// Routed through our own API so the Google Maps key stays server-side.
		return this.http.get("api/address/GeolocateAddress", {
			params: {
				line1: address.line1 || "",
				city: address.city || "",
				state: address.state || "",
				zip: address.zip || "",
				country: address.country || "",
			},
		});
	}

	getCountryCodes() {
		return this.http.get<ICountryCode[]>("api/address/getCountryCodes");
	}

	getCountries(orderId: number) {
		return this.http.get<IShippingCountry[]>("api/order/GetCountries", { params: { orderId: orderId.toString() } });
	}

	getAvailableStates(countryAbbr: string) {
		return this.http.get<IStateModel[]>("api/address/GetAvailableStatesForCountry", { params: { countryAbbr } });
	}
}
